module.exports = __webpack_public_path__ + "img/weixinvideo.55d3668d.png";